import { Box, Button, Modal, Typography } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSuperAdminSingleSuscrip } from "../../../context/SuperAdmin/SingleSuscriptContext";
import CurrentUsersDropdown from "./CurrentUsersDropdown";
import OtherUsersMenu from "./OtherUsersMenu";

const AddUserSuscriptModal = () => {
  const {
    isAddModalOpen,
    toggleAddModal,
    isAdding,
    isLoadingUsers,
    submitSelections,
    suscripcion,
  } = useSuperAdminSingleSuscrip();

  const { idSuscription } = useParams();
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const handleSubmit = () => {
    const body = {
      id_suscripcion: suscripcion.id_suscripcion,
      id_usuarios: selectedUsers,
      id_organizacion: suscripcion.id_organizacion,
    };
    if (idSuscription) {
      console.log(body);
      
      submitSelections(body);
      setSelectedUsers([]);
    }
  };

  const handleClose = () => {
    if (!isAdding) {
      toggleAddModal(false);
    }
  };

  return (
    <Modal
      open={isAddModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "700px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        {isLoadingUsers ? (
          <Typography
            id="edit-subscription-modal-title"
            justifyContent={"center"}
            sx={{
              width: 1,
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Cargando...
          </Typography>
        ) : (
          <>
            <CurrentUsersDropdown />

            <OtherUsersMenu
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
            />

            <Box sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ background: "#336B87" }}
                disabled={isAdding || !selectedUsers.length}
                onClick={handleSubmit}
              >
                Agregar
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AddUserSuscriptModal;
